<template>
    <v-sheet v-if="loading" class="fill-height" style="position: relative">
        <v-overlay absolute color="white">
            <v-progress-circular indeterminate size="100" width="5" color="primary" />
        </v-overlay>
    </v-sheet>
    <v-sheet v-else-if="isAlreadyApplied" class="d-flex flex-column align-center">
        <i class="icon icon-check mb-20 mb-lg-40"></i>
        <v-sheet class="text-center mb-20 mb-lg-40">
            <h3 class="tit mb-8 mb-lg-16"> 채용지원 완료 </h3>
            <p class="page-text--lg grey-6--text">
                "{{ recruitmentSubject }}" 공고에 대한 지원이 완료되었습니다.
            </p>
        </v-sheet>
        <div class="v-btn-group mt-0">
            <v-btn color="primary" class="min-w-140px min-w-lg-160px" @click="$emit('close')"><span>확인</span></v-btn>
        </div>
    </v-sheet>
    <stepper v-else v-model="step" v-bind="{ steps, headerProps }" non-linear>
        <template v-for="{ step, value } in steps">
            <step-resume v-if="value == APPLICATION_WRITIG_STEPS.RESUME.value" :key="step" :slot="step" v-model="form" v-bind="{ formResume, hashTags }" />
            <step-micepec-recrods v-if="value == APPLICATION_WRITIG_STEPS.MICEPEC_RECORDS.value" :key="step" :slot="step" v-model="form" v-bind="{ formResume }" v-on="{ prev }" />
            <step-questions v-if="value == APPLICATION_WRITIG_STEPS.QUESTIONS.value" :key="step" :slot="step" v-model="form" v-bind="{ formResume }" v-on="{ prev }" />
            <step-complete v-if="value == APPLICATION_WRITIG_STEPS.COMPLETED.value" :key="step" :slot="step" v-model="form" v-bind="{ formResume }" v-on="{ prev }" />
        </template>
    </stepper>
</template>

<script>
import api from "@/api";
import { APPLICATION_STATES, APPLICATION_WRITIG_STEPS, initApplication } from "@/assets/variables";

import Stepper from "@/components/dumb/stepper.vue";
import StepResume from "./step-resume.vue";
import StepComplete from "./step-complete.vue";
import StepQuestions from "./step-questions.vue";
import StepMicepecRecrods from "./step-micepec-recrods.vue";

const steps = Object.values(APPLICATION_WRITIG_STEPS).map((item, index) => ({ ...item, step: index + 1 }));

export default {
    components: {
        Stepper,
        StepResume,
        StepComplete,
        StepQuestions,
        StepMicepecRecrods,
    },
    props: {
        _recruitment: { type: String },
        recruitmentSubject: { type: String },
    },
    data: () => ({
        form: initApplication(),
        hashTags: [],

        step: 1,
        steps,
        loading: false,
        headerProps: {
            outlined: true,
            elevation: 0,
        },
        APPLICATION_WRITIG_STEPS,
    }),
    computed: {
        isAlreadyApplied() {
            const { IS_APPLIED, ON_RECRUIT } = APPLICATION_STATES;
            return [IS_APPLIED, ON_RECRUIT].map(({ value }) => value).includes(this.form?.state);
        },
        userHasLoggedIn() {
            return !!this.$store.state.payload?._user;
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        _recruitment() {
            this.init();
        },
        "form.writingStep"(writingStep) {
            this.step = (this.steps || []).find(({ value }) => value == this.form.writingStep)?.step || 1;
        },
    },
    methods: {
        async init() {
            this.loading = true;

            try {
                let { _recruitment } = this;
                this.form = { ...initApplication({ _recruitment }) };

                if (this.userHasLoggedIn) {
                    const { application } = await api.v1.recruitments.application.get({ _recruitment });

                    if (application) {
                        this.form = { ...this.form, ...application, resume: this.formResume(application?.resume) || this.form.resume };
                    } else {
                        this.form = { ...this.form, resume: this.formResume(((await api.v1.person.resume.get()) || {})?.resume) };
                    }
                }

                this.hashTags = (await api.v1.setting.get())?.setting?.hashTags || [];
            } finally {
                this.loading = false;
            }
        },

        formResume(resume) {
            if (resume?.personalInformation?.bornAt) resume.personalInformation.bornAt = resume.personalInformation.bornAt.toDate();
            for (const item of resume?.education?.otherEducations || []) {
                item.tempId = Math.random();
            }
            for (const item of resume?.workExperience?.list || []) {
                item.tempId = Math.random();
                if (item?.duration?.startsAt) item.duration.startsAt = item.duration.startsAt.toDate();
                if (item?.duration?.endsAt) item.duration.endsAt = item.duration.endsAt.toDate();
            }
            return resume;
        },

        prev() {
            console.log(this.step);
            this.step -= 1;
            console.log(this.step);
        },
    },
};
</script>

<style></style>
